export const SOCIAL_URL_MAX_LENGTH = 500;

const HAS_SCHEME = /^[a-z][a-z0-9+.-]*:/i;
const HTTP_URL = /^https?:\/\/\S+$/i;

// A url typed without a scheme resolves as a path on the booking site itself rather than as an external link, so it is stored with https rather than rejected.
export const normalizeSocialUrl = (value: string) => {
  const trimmed = value.trim();

  if (!trimmed || HAS_SCHEME.test(trimmed)) {
    return trimmed;
  }

  return `https://${trimmed}`;
};

export const isSupportedSocialUrl = (value: string) => {
  const normalized = normalizeSocialUrl(value);

  return !normalized || HTTP_URL.test(normalized);
};
